<app-title title=" {{ 'PAGINA_SISTEMAS.TITULO' | translate }}"></app-title>
<section>
  <div
    class="n-container p-5 n-card2 flex flex-wrap flex-column md:flex-row md:justify-content-between row-gap-5 column-gap-4"
  >
    <div>
      <h4>{{ 'PAGINA_SISTEMAS.ID' | translate }}</h4>
      <p>{{sistema.id}}</p>
    </div>
    <div>
      <h4>{{ 'PAGINA_SISTEMAS.NOME' | translate }}</h4>
      <p>{{sistema.nome}}</p>
    </div>
    <div>
      <h4>{{ 'PAGINA_SISTEMAS.STATUS' | translate }}</h4>
      <p>{{sistema.aplicacao}}</p>
    </div>

    <!-- <p-button label="Salvar" type="submit" /> -->
  </div>
</section>

<section class="section-margin">
  <form
    [formGroup]="formBuscarFuncionalidade"
    class="n-form"
    (ngSubmit)="buscarFuncionalidades()"
  >
    <div
      class="n-container p-5 n-card2 flex flex-wrap flex-column md:flex-row md:justify-content-between row-gap-5 column-gap-4"
    >
      <p-floatLabel>
        <p-inputNumber inputId="integeronly" formControlName="id" id="id" />
        <label for="id" class="ng-invalide"
          >{{ 'PAGINA_SISTEMAS.ID' | translate }}</label
        >
      </p-floatLabel>
      <p-floatLabel>
        <input pInputText id="nome" formControlName="nome" />
        <label for="id" class="ng-invalide"
          >{{ 'PAGINA_SISTEMAS.NOME' | translate }}</label
        >
      </p-floatLabel>
      <p-button label="Pesquisar" type="submit" />
    </div>
  </form>
</section>
<section class="section-margin">
  <div class="n-container p-5 n-card2">
    <div>
      <div class="flex justify-content-end">
        <button
          type="button"
          pButton
          pRipple
          icon="pi pi-plus"
          (click)="showAddFuncionalidadeDialog()"
        ></button>
      </div>
      <p-table [value]="funcionalidades" [tableStyle]="{'min-width': '50rem'}">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th>{{ 'PAGINA_SISTEMAS.ID' | translate }}</th>
            <th>{{ 'PAGINA_SISTEMAS.NOME' | translate }}</th>
            <th>{{ 'PAGINA_SISTEMAS.VALOR' | translate }}</th>
            <th>{{ 'PAGINA_SISTEMAS.ACOES' | translate }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-funcionalidade let-columns="columns">
          <tr>
            <td>{{funcionalidade.id}}</td>
            <td>{{funcionalidade.nome}}</td>
            <td>{{funcionalidade.valor}}</td>
            <td>
              <button
              type="button"
              pButton
              pRipple
              icon="pi pi-pencil"
              (click)="showEditarFuncionalidadeDialog(funcionalidade)"
              ></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</section>

<app-voltar></app-voltar>

<!-- Modal Adicionar funcionaliade -->

<p-dialog
  header="Adicionar funcionalidade"
  [modal]="true"
  [(visible)]="showAddFuncionalidade"
  [style]="{ width: '25rem' }"
>
  <form [formGroup]="formAddEditarFuncionalidade" (ngSubmit)="salvarFuncionalidade()">
    <div class="flex align-items-center gap-3 mb-3">
      <p-floatLabel>
        <input pInputText id="nome" formControlName="nome" />
        <label for="id" class="ng-invalide"
          >{{ 'PAGINA_SISTEMAS.NOME' | translate }}</label
        >
      </p-floatLabel>
    </div>
    <div class="flex align-items-center gap-3 mb-5">
      <p-floatLabel>
        <p-inputNumber
          inputId="integeronly"
          formControlName="valor"
          id="valor"
        />
        <label for="valor" class="ng-invalide"
          >{{ 'PAGINA_SISTEMAS.VALOR' | translate }}</label
        >
      </p-floatLabel>
    </div>
    <div class="flex align-items-center gap-3 mb-3">
      <p-floatLabel>
        <input pInputText id="descricao" formControlName="descricao" />
        <label for="descricao" class="ng-invalide"
          >{{ 'PAGINA_SISTEMAS.DESCRICAO' | translate }}</label
        >
      </p-floatLabel>
    </div>
    <div class="flex align-items-center gap-3 mb-3">
      <p-floatLabel>
        <input pInputText id="controller" formControlName="nomeController" />
        <label for="controller" class="ng-invalide"
          >{{ 'PAGINA_SISTEMAS.CONTROLLER' | translate }}</label
        >
      </p-floatLabel>
    </div>
    <div class="flex align-items-center gap-3 mb-3">
      <p-floatLabel>
        <input pInputText id="action" formControlName="nomeAction" />
        <label for="action" class="ng-invalide"
          >{{ 'PAGINA_SISTEMAS.ACTION' | translate }}</label
        >
      </p-floatLabel>
    </div>
    <div class="flex justify-content-end gap-2">
      <p-button
        label="Cancel"
        severity="secondary"
        (onClick)="showAddFuncionalidade = false"
      />
      <p-button label="Save" type="submit" (onClick)="showAddFuncionalidade = false" />
    </div>
  </form>
</p-dialog>

<!-- Modal Editar funcionaliade -->

<p-dialog
  header="Editar funcionalidade"
  [modal]="true"
  [(visible)]="showEditarFuncionalidade"
  [style]="{ width: '25rem' }"
>
  <form [formGroup]="formAddEditarFuncionalidade" (ngSubmit)="salvarEditarFuncionalidade()">
    <div class="flex align-items-center gap-3 mb-3">
      <p-floatLabel>
        <input pInputText id="nome" formControlName="nome" />
        <label for="id" class="ng-invalide"
          >{{ 'PAGINA_SISTEMAS.NOME' | translate }}</label
        >
      </p-floatLabel>
    </div>
    <div class="flex align-items-center gap-3 mb-5">
      <p-floatLabel>
        <p-inputNumber
          inputId="integeronly"
          formControlName="valor"
          id="valor"
        />
        <label for="valor" class="ng-invalide"
          >{{ 'PAGINA_SISTEMAS.VALOR' | translate }}</label
        >
      </p-floatLabel>
    </div>
    <div class="flex align-items-center gap-3 mb-3">
      <p-floatLabel>
        <input pInputText id="descricao" formControlName="descricao" />
        <label for="descricao" class="ng-invalide"
          >{{ 'PAGINA_SISTEMAS.DESCRICAO' | translate }}</label
        >
      </p-floatLabel>
    </div>
    <div class="flex align-items-center gap-3 mb-3">
      <p-floatLabel>
        <input pInputText id="controller" formControlName="nomeController" />
        <label for="controller" class="ng-invalide"
          >{{ 'PAGINA_SISTEMAS.CONTROLLER' | translate }}</label
        >
      </p-floatLabel>
    </div>
    <div class="flex align-items-center gap-3 mb-3">
      <p-floatLabel>
        <input pInputText id="action" formControlName="nomeAction" />
        <label for="action" class="ng-invalide"
          >{{ 'PAGINA_SISTEMAS.ACTION' | translate }}</label
        >
      </p-floatLabel>
    </div>
    <div class="flex justify-content-end gap-2">
      <p-button
        label="Cancel"
        severity="secondary"
        (onClick)="limparFormularioFuncionalidade()"
      />
      <p-button label="Save" type="submit" (onClick)="showEditarFuncionalidade = false" />
    </div>
  </form>
</p-dialog>


